import { makeStyles, Typography } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import React, { useEffect } from "react";
import { Wrapper } from "../base/Wrapper";
import TitleBar from "../TitleBar";
import { MdBrightness2, MdBrightness4, MdBrightness5 } from "react-icons/md";
import { useRecoilState } from "recoil";
import { themeState } from "../../lib/recoil";

const useStyles = makeStyles((theme) => ({
  toggleGroup: {
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(3),
  },
  toggleIcon: {
    fontSize: "2rem",
  },
  text: {
    marginBottom: theme.spacing(3),
  },
}));

function Accessibility() {
  const classes = useStyles();

  const [themePreference, setThemePreference] = useRecoilState(themeState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleThemeChange = (e, newThemePreference) => {
    if (newThemePreference !== null) {
      setThemePreference(newThemePreference);
    }
  };

  return (
    <>
      <TitleBar title="Aussehen & Barrierefreiheit" navigateTo="/profile" colorPrimary />
      <Wrapper>
        <Typography component="h2" variant="h5">
          Erscheinungsbild
        </Typography>
        <Typography variant="subtitle2">
          Wähle aus wie die App dargestellt werden soll.
          <br />
          <MdBrightness5 /> heller Modus
          <br />
          <MdBrightness4 /> Systemeinstellungen (automatisch)
          <br />
          <MdBrightness2 /> dunkler Modus
        </Typography>
        <div>
          <ToggleButtonGroup
            value={themePreference}
            exclusive
            className={classes.toggleGroup}
            onChange={handleThemeChange}
            aria-label="Auswahl des Farbschemas"
          >
            <ToggleButton value="light" aria-label="Heller Modus">
              <MdBrightness5 className={classes.toggleIcon} />
            </ToggleButton>
            <ToggleButton value="auto" aria-label="Automatischer Modus">
              <MdBrightness4 className={classes.toggleIcon} />
            </ToggleButton>
            <ToggleButton value="dark" aria-label="Dunkler Modus">
              <MdBrightness2 className={classes.toggleIcon} />
            </ToggleButton>
          </ToggleButtonGroup>
          <Typography component="h2" variant="h5" gutterBottom>
            Barrierefreiheit
          </Typography>
          <Typography variant="subtitle2" className={classes.text}>
            Wir bemühen uns, unsere App barrierefrei zu gestalten. Die Erklärung zur digitalen
            Barrierefreiheit wird im Gesetz über die barrierefreie Informations-und
            Kommunikationstechnik Berlin (BIKTG Bln) verlangt. Die technischen Anforderungen zur
            Barrierefreiheit ergeben sich aus der BITV 2.0.
          </Typography>
          <Typography component="h2" variant="h6" gutterBottom>
            Wann wurde die Erklärung zur Barrierefreiheit erstellt?
          </Typography>
          <Typography variant="subtitle2" className={classes.text}>
            Diese Erklärung wurde am 15.06.2021 erstellt bzw. überarbeitet. Die technische
            Überprüfung der Barrierefreiheit erfolgte durch Selbstbewertung anhand der
            BITV/WCAG-Selbstbewertung anhand des WCAG 2.0 Standards.
          </Typography>
          <Typography component="h2" variant="h6" gutterBottom>
            Wie barrierefrei ist das Angebot?
          </Typography>
          <Typography variant="subtitle2" className={classes.text}>
            Die Anwendung ist nur teilweise barrierefrei. Es werden nur teilweise die Anforderungen
            der BITV 2.0 erfüllt und sich an dem WCAG 2.0 A Standard orientiert.
          </Typography>
          <Typography component="h2" variant="h6" gutterBottom>
            Welche Barrieren wurden überwunden?
          </Typography>
          <ul style={{ marginBottom: "24px" }}>
            <li>Alternativtexte</li>
            <li>Sichtbarer Fokus</li>
            <li>Navigation mit der Tastatur</li>
            <li>Anpassbare Bildschirmbreite und Bildschirmausrichtung</li>
          </ul>
          <Typography component="h2" variant="h6" gutterBottom>
            Welche Bereiche sind nicht barrierefrei?
          </Typography>
          <Typography variant="subtitle2">
            Es bestehen Barrieren, die nach BITV 2.0 noch unvereinbar sind. Diese sind:
          </Typography>
          <ul style={{ marginBottom: "24px" }}>
            <li>Anpassbare Textabstände</li>
            <li>Keine taktile oder auditive Rückmeldung bei Toggle Elementen</li>
            <li>Fehlende Alternative für komplexe Zeigergesten</li>
            <li>Hauptsprache wird nicht angegeben</li>
            <li>Fehlende leichte Sprache und Gebärdensprache</li>
          </ul>
          <Typography variant="subtitle2">
            Wir arbeiten daran, die uns bekannten und bestehenden Barrieren im Rahmen einer
            Überarbeitung der Dienste zu beheben und somit die Zugänglichkeit der Seite zu
            verbessern.
          </Typography>
        </div>
      </Wrapper>
    </>
  );
}

export default Accessibility;
